import type { ReactElement } from "react";

import { AnchorButton } from "@rootreeweb/ui";

import image from "@/assets/holiday-cards/holiday-card-colouring-pages.png";
import { DayDefinition } from "../DayDefinition.js";

/**
 * Class Colouring_Pages
 *
 * Represents the Colouring Pages card.
 */
export class Colouring_Pages extends DayDefinition {
	/** The CSS class to use for the card. */
	public className = "hl:bg-orange2022";
	public image = image;

	/** The slug for the card. Used to identify the card for css, etc. */
	public slug = "colouring-pages";

	/** Get the display for the card in English. */
	public initENCard(): void {
		this.title = "Colouring Pages";
		this.content = (
			<>
				<p className="hl:whitespace-pre-line">
					{`Colouring on a snowy day With a cup of hot cocoa and cream
					Is a family activity that certainly
					Makes wintery days a dream
					Two colouring pages for both kids and kids at heart
					Time will fly and bring you peace
					From the moment that you start`}
				</p>
				<ColouringPages language={"EN"} />
			</>
		);
	}

	/** Get the display for the card in French. */
	public initFRCard(): void {
		this.title = "Coloriages";
		this.content = (
			<>
				<p className="hl:whitespace-pre-line">
					{`Lorsqu'il neige, rien de tel qu'un bon coloriage au chaud avec une tasse de chocolat à la crème.
					L'activité d'hiver rêvée pour adoucir l’ambiance familiale.
					Deux pages de coloriage à destination des petits ou des grands qui ont gardé leur âme d'enfant.
					Dès le premier coup de crayon, le temps s'arrête et vous procure un sentiment de paix intérieure.`}
				</p>
				<ColouringPages language={"FR"} />
			</>
		);
	}
}

/**
 * Display the colouring pages grid.
 *
 * @param props The properties for the component.
 * @param props.language The language to display the colouring pages in.
 * @returns The colouring pages grid.
 */
function ColouringPages(props: { language: "EN" | "FR" }): ReactElement {
	const language = props.language;
	return (
		<>
			<div className="hl:grid hl:gap-4 hl:lg:grid-cols-2">
				<div>
					<p>
						<strong>
							{language === "FR"
								? "Coloriages pour enfants"
								: "Children’s Colouring Page"}
						</strong>
					</p>
					<a
						href="https://rootree.ca/wp-content/uploads/2022/11/Rootree_HolidayCampaign_ColouringPage.pdf"
						target="_blank"
					>
						<img
							alt="Colouring Pages"
							src="https://rootree.ca/wp-content/uploads/2022/11/Colouring-Paper-1.jpeg"
						/>
					</a>
				</div>

				<div>
					<p>
						<strong>
							{language === "FR" ? "Coloriages zen" : "Mindful Colouring Page"}
						</strong>
					</p>
					<a
						href="https://rootree.ca/wp-content/uploads/2022/11/Rootree_HolidayCampaign_ColouringPage.pdf"
						target="_blank"
					>
						<img
							alt="Colouring Pages"
							src="https://rootree.ca/wp-content/uploads/2022/11/Colouring-Paper-2.jpg"
						/>
					</a>
				</div>
			</div>

			<AnchorButton
				className={"hl:mx-auto hl:no-underline"}
				colour={"white"}
				href="https://rootree.ca/wp-content/uploads/2022/11/Rootree_HolidayCampaign_ColouringPage.pdf"
				target="_blank"
			>
				{language === "FR"
					? "Téléchargez des coloriages"
					: "Download Colouring Pages"}
			</AnchorButton>
		</>
	);
}
